export default __webpack_public_path__ + "static/media/Logout.2773ffef.svg";